import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <span className="text-foreground-400">/</span>
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-primary-500 transition-colors cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}